import { IMPORTED_USERS } from "redux/reducers/entities/imported/actionNames"

const mapper = {
    [IMPORTED_USERS](_, result, originalPayload) {
        const mappedImportedUsers = result.map(({ importedAt, ...data }) => ({
            importedAt: new Date(importedAt),
            ...data,
        }))

        return { result: mappedImportedUsers, originalPayload }
    },
}

export default mapper
